import { IconSelector, IconChevronUp, IconChevronDown } from "@tabler/icons";
import React, { useContext } from "react";
import "./ColumnHeader.scss";
import { TableHeaderContext } from "./TableHeaderContext";


const ColumnHeader = ({ text , name }) => {

    const { order, setOrder } = useContext(TableHeaderContext);

    const handleClick = () =>{
       if(!order.orderBy || order.orderBy !== name) {
        setOrder({orderBy: name, direction: "up"});
       } else if(order.direction === "down") {
        setOrder({orderBy: name, direction: "up"});
       } else  {
        setOrder({orderBy: name, direction: "down"});
       }

    }

    const showArrow = () => {
        if((order.orderBy !== null && order.orderBy !== name) || order.direction === null) {
            return <span ><IconSelector fill="#f4f4f5" className="default"/></span>
        }

        if (order.direction === "up") {
            return <span><IconChevronDown fill="#f4f4f5" className="down"/></span>
        }
        return <span ><IconChevronUp fill="#f4f4f5" className="up"/></span>
    }
    
    return (
      <div className="ColumnHeader" onClick={handleClick}> 
       {text} {showArrow()}
      </div>
    );
  };
  
  export default ColumnHeader;